import React from 'react';

interface Props {
  children?: React.ReactNode;
}

export const ErrorMessage: React.FC<Props> = ({ children }) => {
  return <p className="mt-2 text-sm text-red-600">{children}</p>;
};
